import { createSlice } from "@reduxjs/toolkit";
import { BonusTransactionState } from "./types";
import { fetchBonusTransaction } from "./bonus-transaction-thunk";
import { ErrorType } from "@/shared/types";

const initialState: BonusTransactionState = {
    transaction: {
        id: "",
        amount_nano: 0,
        bonus_id: "",
        comment: "",
        created_date: "1970-01-01T00:00:00Z",
        check_id: "",
        from: {
            address: "",
            client_id: "",
            system_id: "",
            type: 1,
            type_str: "system"
        },
        to: {
            address: "",
            client_id: "",
            system_id: "",
            type: 1,
            type_str: "system"
        },
        reason_type: 1,
        reason_id: "",
        reason_type_str: "processing_debit",
        store_id: ""
    },
    stores: {},
    checks: {},
    error: null,
    isLoading: false
}

const bonusTransactionSlice = createSlice({
    name: 'bonusTransaction',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(fetchBonusTransaction.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchBonusTransaction.fulfilled, (state, action) => {
                state.isLoading = false
                state.stores = action.payload.stores
                state.checks = action.payload.checks
                state.transaction = action.payload.transaction
                state.error = null
            })
            .addCase(fetchBonusTransaction.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.payload as ErrorType ?? null
            })
    },
})

export default bonusTransactionSlice.reducer